import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 50px 0;

  a {
    background: #d5572f;
    color: white;
    text-decoration: none;
    font-weight: 600;
    font-size: 1.7rem;
    display: flex;
    gap: 8px;
    width: fit-content;
    padding: 8px 24px;
    line-height: 24px;
    text-transform: uppercase;
    transition: 0.3s;
    clip-path: polygon(
      3% 0%,
      /* coin haut gauche coupé */ 100% 0%,
      /* coin haut droit */ 97% 100%,
      /* coin bas droit coupé */ 0% 100% /* coin bas gauche */
    );

    :hover {
      background: #08284d;
    }

    @media (max-width: 767px) {
      font-size: 1.5rem;
    }
  }
`;

export default function CampaignButton() {
  const [link, setLink] = React.useState(undefined);

  React.useEffect(() => {
    const search = window.location.search;
    const link =
      "https://dons.jaimelinfo.fr/lemedia-tv" +
      (search
        ? search + "&default_interval=m&amount=15"
        : "?medium=website&source=lemedia&campaign=capsur10k&default_interval=m&amount=15");

    setLink(link);
  }, [link]);

  return (
    <Container>
      <a
        className="dbox-donation-button"
        id="preview_inline_popup_button"
        href={link}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-pointer"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M7.904 17.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l1.047 -1.047a1.067 1.067 0 0 0 0 -1.509l-4.907 -4.907l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563" />
        </svg>
        Je sauve Le Média !
      </a>
    </Container>
  );
}
